import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import Link, {RouterLink} from "@irati/ui/src/Link"
import {Body, H3} from "@irati/ui/src/Typography"
import {hoverRaise} from "@irati/ui/src/global/css/animations"

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`

export const StyledRouterLink = styled(RouterLink)`
  &:hover {
    text-decoration: none;
  }
`

interface ProductCardProps {
  isActive: boolean
  isLast: boolean
}

export const ProductCard = styled(Card)<ProductCardProps>`
  ${({theme, isActive, isLast}) => css`
    background-color: ${isActive ? theme.colors.greys.white : theme.colors.greys.light};
    display: flex;
    align-items: center;
    margin-bottom: ${isLast ? "0px" : "15px"};
    overflow: hidden;
    padding: 0px;
  
    &:last {
      margin-bottom: 0px;
    }
  
    ${theme.mediaQueries.maxWidthMedia.tablet`
      padding: 0px;
    `}
    ${hoverRaise}
  `}
`

export const ProductContent = styled.div`
  display: flex;
  text-align: left;
  text-transform: none;
  align-items: center;
  width: 100%;
  padding: ${({theme}) => `0 ${theme.spacing.two}`};
  justify-content: space-between;
`
interface ProductLogoProps {
  backgroundColor: string
}

export const ProductLogo = styled.div<ProductLogoProps>`
  background: ${({backgroundColor}) => backgroundColor};
  height: 90px;
  padding: 30px;
  width: 90px;
`

export const ResponsiveH3 = styled(H3)`
  ${({theme}) => css`
    display: inline-block;
    width: 240px;
    ${theme.mediaQueries.maxWidthMedia.tablet`
      display: block;
      width: initial;
    `}
  `}
`

export const ResponsiveBody = styled(Body)`
  ${({theme}) => css`
    display: inline-block;
    ${theme.mediaQueries.maxWidthMedia.tablet`
      display: block;
    `}
  `}
`
